"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const lodash_1 = __importDefault(require("lodash/lodash"));
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const ProductFeatures_1 = __importDefault(require("./partials/ProductFeatures"));
const FeatureTabs_1 = __importDefault(require("./partials/FeatureTabs"));
const ProductDetails_module_scss_1 = __importDefault(require("./ProductDetails.module.scss"));
const NORMALIZED_FIRMNESSES = {
    'luxury firm': 'medium firm',
    'relaxed firm': 'medium firm',
    'luxury plush': 'medium firm',
    'gentle firm': 'firm'
};
const DETAIL_KEYS = {
    firmness: 'firmness',
    height: 'height',
    material: 'material'
};
/**
 *
 * @param {object} props
 * @param {string} props.selectedFirmness
 * @param {{
 *  sortOrder: number,
 *  key: string,
 *  name: string,
 *  content: {
 *    label: string,
 *    description: string,
 *    features: string
 *  }[]
 * }[]} props.details
 */
const ProductDetails = ({ details, selectedFirmness }) => {
    return details.map((detail, index) => {
        if (!detail.key && !detail.content) {
            return null;
        }
        const key = (0, camelCase_1.default)(detail.key);
        let defaultIndex = 0;
        // set the default firmness selection to match the selected filter
        if (selectedFirmness && key === DETAIL_KEYS.firmness) {
            const firmnessDetail = details[index];
            const matchingContentIndex = firmnessDetail.content.findIndex(({ label }) => {
                const lowerLabel = label && label.toLowerCase();
                if (lowerLabel) {
                    if (lowerLabel in NORMALIZED_FIRMNESSES) {
                        return selectedFirmness === NORMALIZED_FIRMNESSES[lowerLabel];
                    }
                    return selectedFirmness === lowerLabel;
                }
                return false;
            });
            if (matchingContentIndex > -1) {
                defaultIndex = matchingContentIndex;
            }
        }
        let sectionContent = null;
        switch ((0, camelCase_1.default)(detail.key)) {
            case DETAIL_KEYS.firmness:
            case DETAIL_KEYS.height:
            case DETAIL_KEYS.material:
                sectionContent = (0, jsx_runtime_1.jsx)(FeatureTabs_1.default, { modifier: key, featureArray: detail.content, defaultIndex: defaultIndex });
                break;
            default:
                sectionContent = detail.content.map(({ features }, i) => features && ((0, jsx_runtime_1.jsx)(ProductFeatures_1.default, { features: features }, `feature-${i}`)));
                break;
        }
        return sectionContent && ((0, jsx_runtime_1.jsxs)("section", { className: ProductDetails_module_scss_1.default.contentSection, children: [(0, jsx_runtime_1.jsxs)("h2", { children: [detail.name || `${(0, lodash_1.default)(detail.key)}`, ":"] }), sectionContent] }, detail.key));
    });
};
ProductDetails.propTypes = {
    details: prop_types_1.default.arrayOf(prop_types_1.default.shape({
        key: prop_types_1.default.string,
        defaultIndex: prop_types_1.default.number,
        content: prop_types_1.default.arrayOf(prop_types_1.default.shape({
            label: prop_types_1.default.string,
            description: prop_types_1.default.string,
            features: prop_types_1.default.node
        }))
    })),
    filterValues: prop_types_1.default.object
};
exports.default = ProductDetails;
//# sourceMappingURL=ProductDetails.js.map